import { render, staticRenderFns } from "./NewSuccess.vue?vue&type=template&id=1a91f794&scoped=true"
import script from "./NewSuccess.vue?vue&type=script&lang=js"
export * from "./NewSuccess.vue?vue&type=script&lang=js"
import style0 from "./NewSuccess.vue?vue&type=style&index=0&id=1a91f794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a91f794",
  null
  
)

export default component.exports